import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AdminAgencyBrandingRow {
  agency_id: string;
  agency_email: string;
  has_logo: boolean;
  has_custom_colors: boolean;
  primary_color: string;
  secondary_color: string;
  font_family: string;
  logo_url: string | null;
  logo_dark_url: string | null;
  favicon_url: string | null;
  login_message: string | null;
  dashboard_footer: string | null;
  powered_by_text: string | null;
  email_from_name: string | null;
  support_email: string | null;
  terms_url: string | null;
  privacy_url: string | null;
  allow_tenant_branding: boolean;
  custom_domain: string | null;
  domain_status: string | null;
  ssl_status: string | null;
  branding_updated_at: string | null;
}

export function useAdminAgencyBranding() {
  return useQuery({
    queryKey: ["admin", "agency-branding"],
    queryFn: async (): Promise<AdminAgencyBrandingRow[]> => {
      const { data, error } = await supabase.rpc("calie_admin_list_agency_branding");

      if (error) {
        throw new Error(error.message);
      }

      return (data || []) as AdminAgencyBrandingRow[];
    },
  });
}
